import{jsx as r}from"react/jsx-runtime";import e from"@mui/joy/Typography";var o=({children:o})=>r(e,{level:"body-xs",fontWeight:500,textColor:"neutral.500",children:o});export{o as SidebarSectionLabel};
//# sourceMappingURL=index.js.map